import { TILE_SIZE } from "../../constants";
import { TileLayer } from "./tile-layer";
export var ObjectTile;
(function (ObjectTile) {
    ObjectTile[ObjectTile["Empty"] = 0] = "Empty";
    ObjectTile[ObjectTile["Spawn"] = 1] = "Spawn";
    ObjectTile[ObjectTile["Goal"] = 2] = "Goal";
    // Not actually used in the tile set but calculated from the things below.
    ObjectTile[ObjectTile["Button"] = 3] = "Button";
    ObjectTile[ObjectTile["Spikes"] = 4] = "Spikes";
    ObjectTile[ObjectTile["Bridge"] = 5] = "Bridge";
    ObjectTile[ObjectTile["RedButton"] = 10] = "RedButton";
    ObjectTile[ObjectTile["RedSpikes"] = 11] = "RedSpikes";
    ObjectTile[ObjectTile["RedBridge"] = 12] = "RedBridge";
    ObjectTile[ObjectTile["YellowButton"] = 20] = "YellowButton";
    ObjectTile[ObjectTile["YellowSpikes"] = 21] = "YellowSpikes";
    ObjectTile[ObjectTile["YellowBridge"] = 22] = "YellowBridge";
    ObjectTile[ObjectTile["BlueButton"] = 30] = "BlueButton";
    ObjectTile[ObjectTile["BlueSpikes"] = 31] = "BlueSpikes";
    ObjectTile[ObjectTile["BlueBridge"] = 32] = "BlueBridge";
})(ObjectTile || (ObjectTile = {}));
export var ButtonColor;
(function (ButtonColor) {
    ButtonColor[ButtonColor["Red"] = 1] = "Red";
    ButtonColor[ButtonColor["Yellow"] = 2] = "Yellow";
    ButtonColor[ButtonColor["Blue"] = 3] = "Blue";
})(ButtonColor || (ButtonColor = {}));
export function getButtonColor(tile) {
    if (tile == ObjectTile.Empty) {
        return undefined;
    }
    return Math.floor(tile / 10);
}
// Only relevant for colored tiles.
export function getNormalTileType(tile) {
    if (tile >= ObjectTile.RedButton) {
        return (tile % 10) + ObjectTile.Button;
    }
    return tile;
}
// Position of the tile in the tileset.
const tilePositions = {
    [ObjectTile.Spawn]: { x: 11, y: 0 },
    [ObjectTile.Goal]: { x: 11, y: 1 },
    [ObjectTile.RedButton]: { x: 11, y: 2 },
    [ObjectTile.RedSpikes]: { x: 11, y: 4 },
    [ObjectTile.RedBridge]: { x: 11, y: 6 },
    [ObjectTile.YellowButton]: { x: 10, y: 2 },
    [ObjectTile.YellowSpikes]: { x: 10, y: 4 },
    [ObjectTile.YellowBridge]: { x: 10, y: 6 },
    [ObjectTile.BlueButton]: { x: 9, y: 2 },
    [ObjectTile.BlueSpikes]: { x: 9, y: 4 },
    [ObjectTile.BlueBridge]: { x: 9, y: 6 },
};
export class ObjectLayer extends TileLayer {
    renderTile(context, pos, level) {
        const tile = this.getTile(pos);
        const renderPos = { x: pos.x * TILE_SIZE, y: pos.y * TILE_SIZE };
        const tilePos = tilePositions[tile];
        if (tilePos == undefined) {
            return;
        }
        const pos2 = { x: tilePos.x, y: tilePos.y };
        const buttonColor = getButtonColor(tile);
        if (buttonColor != undefined && level.buttonState[buttonColor]) {
            pos2.y += 1;
        }
        this.drawTile(context, { tilePos: pos2, renderPos });
    }
}
